import { TruncatedTextContent } from '@/features/truncated-text-content/ui/TruncatedTextContent';

export { TruncatedTextContent };
